import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ProjectType } from '../models/ProjectType';
import { ProjectTypeService } from '../Services/ProjectType.Service';
import { Rank } from '../models/Rank';
import { RankService } from '../Services/Rank.Service';
import { RankDifficulty } from '../models/RankDifficulty';
import { RankDifficultyService } from '../Services/RankDifficulty.Service';
import { InvestmentType } from '../models/InvestmentType';
import { InvestmentTypeService } from '../Services/InvestmentType.Service';
import { MilestoneImplemented } from '../models/MilestoneImplemented';
import { MilestoneImplementedService } from '../Services/MilestoneImplemented.Service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CreateKaizen } from '../models/Kaizen';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-rank',
    templateUrl: './rank.component.html',
    styleUrls: ['./rank.component.css'],
    standalone: false
})
export class RankComponent implements OnInit {
  CreateKaizenRank : CreateKaizen = new CreateKaizen();
  @Input() CreateKaizen: CreateKaizen = new CreateKaizen();
  @Output() emitKaizenRank: EventEmitter<CreateKaizen> = new EventEmitter<CreateKaizen>();

  formRank!: UntypedFormGroup;
  requiredLegend: string = '* = required field';
  projectTypes !: ProjectType[];
  investmentTypes !: InvestmentType[];
  ranks !: Rank[];
  rankDifficulties !: RankDifficulty[];
  milestonesImplemented !: MilestoneImplemented[];


  constructor(private ProjectTypeService: ProjectTypeService,
    private InvestmentTypeService: InvestmentTypeService,
    private RankService: RankService,
    private RankDifficultyService: RankDifficultyService,
    private MilestoneImplementedService: MilestoneImplementedService,
    private formBuilder: UntypedFormBuilder


  ) { }

  ngOnInit() {
    this.initiateDD();
    this.formRank = this.formBuilder.group({
      projectTypeID: [''],
      investmentTypeID: ['', Validators.required],
      rankID: [''],
      rankDecisionTiming: [''],
      rankDifficultyID: [''],
      rankChangeDescription: ['', Validators.maxLength(2000)],
      milestoneImplementedID: [''],
    });
  }
  initiateDD = async () => {
    this.projectTypes = (await firstValueFrom(this.ProjectTypeService.getProjectTypes()))?.data || [];
    this.investmentTypes = (await firstValueFrom(this.InvestmentTypeService.getInvestmentTypes()))?.data || [];
    this.ranks = (await firstValueFrom(this.RankService.getRanks()))?.data || [];
    this.rankDifficulties = (await firstValueFrom(this.RankDifficultyService.getRankDifficulties()))?.data || [];
    this.milestonesImplemented = (await firstValueFrom(this.MilestoneImplementedService.getMilestonesImplemented()))?.data || [];
    this.formRank.controls['projectTypeID'].setValue(this.CreateKaizen.projectTypeID);
    this.formRank.controls['investmentTypeID'].setValue(this.CreateKaizen.investmentTypeID);
    this.formRank.controls['rankID'].setValue(this.CreateKaizen.rankID);
    this.formRank.controls['rankDecisionTiming'].setValue(this.CreateKaizen.rankDecisionTiming);
    this.formRank.controls['rankDifficultyID'].setValue(this.CreateKaizen.rankDifficultyID);
    this.formRank.controls['rankChangeDescription'].setValue(this.CreateKaizen.rankChangeDescription);
    this.formRank.controls['milestoneImplementedID'].setValue(this.CreateKaizen.milestoneImplementedID);

    this.CreateKaizenRank.projectTypeID = this.CreateKaizen.projectTypeID;
    this.CreateKaizenRank.investmentTypeID = this.CreateKaizen.investmentTypeID;
    this.CreateKaizenRank.rankID = this.CreateKaizen.rankID;
    this.CreateKaizenRank.rankDecisionTiming = this.CreateKaizen.rankDecisionTiming;
    this.CreateKaizenRank.rankDifficultyID = this.CreateKaizen.rankDifficultyID;
    this.CreateKaizenRank.rankChangeDescription = this.CreateKaizen.rankChangeDescription;
    this.CreateKaizenRank.milestoneImplementedID = this.CreateKaizen.milestoneImplementedID;
    this.emitRank();
  }
  emitRank() {
    this.emitKaizenRank.emit(this.CreateKaizenRank);
  }
  changeProjectType(e: any) {
    this.CreateKaizenRank.projectTypeID = e.target.value == '' ? null : e.target.value;
    this.emitRank();
  }
  changeinvestmentType(e: any) {
    this.CreateKaizenRank.investmentTypeID = e.target.value;
    this.emitRank();
  }

  changeRank(e: any) {
    this.CreateKaizenRank.rankID = e.target.value == '' ? null : e.target.value;
    this.emitRank();
  }
  changeRankDecisionTiming(e: any) {
    this.CreateKaizenRank.rankDecisionTiming =  e.target.value == null ? null : new Date(e.target.value); 
    this.emitRank();
  }
  changeRankDifficulty(e: any) {
    this.CreateKaizenRank.rankDifficultyID = e.target.value == '' ? null : e.target.value;
    this.emitRank();
  }
  changeRankChangeDescription(e: any) {
    this.CreateKaizenRank.rankChangeDescription = e.target.value;
    this.emitRank();
  }
  changeMilestoneImplemented(e: any) {
    this.CreateKaizenRank.milestoneImplementedID = e.target.value == '' ? null : e.target.value;
    this.emitRank();
  }
  convertDateFormat(dateString: string): string {
    const parts = dateString.split('/');
    const month = parts[0].padStart(2, '0');
    const day = parts[1].padStart(2, '0');
    const year = parts[2];
  
    return `${year}-${day}-${month} 00:00:00.000`;
  }
}